import React, { useState, useEffect } from 'react';
import "./header.css";

const Header = () => {
    /* ============== Change Background Header ============= */
    useEffect(() => {
        const changeHeaderBackground = () => {
            const header = document.querySelector(".header");
            // when the scroll is higher than 80 viewport height, add the scroll-header class to the header tag
            if (window.scrollY >= 80) {
                header.classList.add("scroll-header");
            } else {
                header.classList.remove("scroll-header");
            }
        };

        window.addEventListener("scroll", changeHeaderBackground);
        
        // Cleanup function to remove event listener
        return () => {
            window.removeEventListener("scroll", changeHeaderBackground);
        };
    }, []);

    /* ============== Toggle Menu ============= */
    const [Toggle, showMenu] = useState(false);
    const [activeNav, setActiveNav] = useState("#home");
    
    return (
        <header className="header">
            <nav className="nav container">
                <a href="index.html" className="nav__logo">jeco</a>

                <div className={Toggle ? "nav__menu show-menu" : "nav__menu"}>
                    <ul className="nav__list grid">
                        <li className="nav__item">
                            <a 
                                href="#home"
                                onClick={() => setActiveNav('#home')} 
                                className={
                                    activeNav === "#home" ? "nav__link active-link" 
                                    : "nav__link"
                                }
                            >
                                <i className="uil uil-estate nav__icon"></i> Home
                            </a>
                        </li>

                        <li className="nav__item">
                            <a href="#about" onClick={() => setActiveNav('#about')} 
                                className={
                                    activeNav === "#about" ? "nav__link active-link" 
                                    : "nav__link"
                                } 
                            >
                                <i className="uil uil-users-alt nav__icon"></i> About
                            </a>
                        </li>

                        <li className="nav__item">
                            <a href="#services" className="nav__link">
                                <i className="uil uil-briefcase-alt nav__icon"></i> Services
                            </a>
                        </li>

                        <li className="nav__item">
                            <a href="#contact" className="nav__link">
                                <i className="uil uil-message nav__icon"></i> Contact
                            </a>
                        </li>
                    </ul>

                    <i className="uil uil-times nav__close" onClick={() => showMenu(!Toggle)}></i>
                </div>

                <div className="nav__toggle" onClick={() => showMenu(!Toggle)}>
                    <i className="uil uil-apps"></i>
                </div>
            </nav>
        </header>
    )
}

export default Header;
